<template>
  <!-- 征稿函发布 -->
  <div class="form-content-container" style="overflow: hidden">
    <Form
      class="form-container"
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <FormItem class="form-item" prop="curNum">
        <div class="title">
          <Input
            class="titleInput"
            v-model="formValidate.curNum"
            :autosize="true"
            type="textarea"
            placeholder="请输入标题(5-50字)"
          />
          <div class="number">
            <span :class="formValidate.curNum.length > 50 ? 'fontColor' : ''">{{
              formValidate.curNum.length
            }}</span>
            / 50
          </div>
        </div>
      </FormItem>
      <FormItem
        class="form-item"
        label="正文"
        prop="content"
        ref="FormItemContent"
      >
        <Editor
          :id="'editor'"
          v-model="formValidate.content"
          :placeholder="'请输入正文'"
        />
      </FormItem>
      <FormItem class="form-item" label="关键词" prop="keyword">
        <Input
          placeholder="请输入关键词，多个关键词之间用英文逗号“,”隔开"
          v-model.trim="formValidate.keyword"
        />
      </FormItem>
      <FormItem
        class="form-item"
        label="摘要"
        prop="abstract"
        :rules="{
          type: 'string',
          max: 200,
          message: '摘要限制200个字',
          trigger: 'blur',
        }"
      >
        <div class="title abstract">
          <Input
            class="titleInput"
            v-model="formValidate.abstract"
            :autosize="true"
            type="textarea"
            placeholder="请输入摘要（摘要会在列表等区域外露，帮助用户快速了解内容，如不填写则默认抓取正文前200字用做展示）"
          />
          <div class="number">
            <span
              :class="formValidate.abstract.length > 200 ? 'fontColor' : ''"
              >{{ formValidate.abstract.length }}</span
            >
            /200
          </div>
        </div>
      </FormItem>
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          v-throttleClick="2000"
          :disabled="canClick"
          @click="handleSubmit(formValidate, 1)"
          >保存</Button
        >
        <Button
          v-throttleClick="2000"
          :disabled="canClick"
          @click="handleSubmit(formValidate, 2)"
          >发布</Button
        >
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import Editor from "../../components/editor";
import ruleUtils from "@/utils/ruleValidate.js";
export default {
  components: {
    AuthenticationModel,
    Editor,
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
    if (this.$route.query.id) {
      this.getEcho(this.formValidate);
      this.isShow = false;
    } else {
      setTimeout(() => {
        this.getTrees();
      }, 1000);
    }
  },
  data() {
    return {
      isShow: true,
      canClick: false,
      isFlag: false,
      tempArr: [],
      picture: "",
      formValidate: {
        content: "",
        curNum: "",
        keyword: "",
        abstract: "",
      },
      ruleValidate: ruleUtils,
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 10,
        },
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
    "formValidate.content"() {
      this.$refs.FormItemContent.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
  },
  methods: {
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview({
        ...this.previewData.data,
      });
      console.log(resp.data);
      let URL = this.$router.resolve({
        path: "/fillingpreview",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    // 回显
    async getEcho(f) {
      const resp = await this.$apis.userServe.getLetter({
        id: this.$route.query.id,
      });
      const r = resp.data;
      f.keyword = r.keywords;
      f.content = r.content;
      f.curNum = r.title;
      f.abstract = r.summary;
    },
    // 提交表单按钮
    async handleSubmit(formValidate, status) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          const { data } = await this.$apis.userServe.addLetter({
            id: this.$route.query.id || this.previewData.data.articleId || null,
            subMenu: status,
            title: formValidate.curNum,
            content: formValidate.content,
            keywords: formValidate.keyword,
            summary: formValidate.abstract,
          });
          if (data.resultCode !== "200") {
            this.canClick = false;
            this.$Message.error(data.resultDesc);
          } else {
            this.$Message.success(status === 1 ? "保存成功" : "发布成功");
            this.previewData = data;
            this.isShow = false;
            this.canClick = false;
            if (status === 1) return;
            this.$router.push("/user/zghmrg");
            // this.clearField(); // 清空
          }
        } else {
          this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    clearField() {
      this.formValidate.content = "";
      this.formValidate.curNum = "";
      this.formValidate.keyword = "";
      this.formValidate.abstract = "";
    },
  },
};
</script>

<style lang="scss" scoped>
#text-container ::v-deep table {
  th,
  td {
    width: 200px;
    height: 35px;
    vertical-align: top;
    word-break: break-all;
  }
}
#text-container ::v-deep .placeholder {
  color: #999;
}
#text-container ::v-deep .w-e-text-container {
  z-index: 1 !important;
}
#toolbar-container ::v-deep .w-e-toolbar {
  justify-content: center;
}
#text-container {
  width: 100%;
  min-height: 500px;
  border: none;
  outline: none;
  padding: 4px 7px;
  color: #515a6e;
}
::v-deep .ivu-tree-children li {
  display: flex;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}
::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}

.ivu-input-wrapper ::v-deep textarea {
  border: none;
}
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  min-height: 800px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 80px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
      align-items: center;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      height: 100%;
      line-height: 38px;
      position: relative;
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
      .fontColor {
        color: red;
      }
    }
    .abstract {
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 14px;
          resize: none;
        }
      }
    }
    .left,
    .right {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .plus {
        width: 30px;
        height: 30px;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        font-size: 2em;
      }
    }
    .left {
      border-right: 1px solid #dcdcdc;
      width: 355px;
    }
    .right {
      margin-left: 10px;
      width: 642px;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
    }
    .year {
      width: 299px;
      border-right: 1px solid #dcdcdc;
    }
    .center {
      width: 323px;
      border-right: 1px solid #dcdcdc;
    }
    .stage {
      width: 374px;
    }
    label {
      white-space: nowrap;
      margin-right: 20px;
    }
    .checkbox {
      width: 970px;
      display: flex;
      padding-left: 7px;
      label {
        margin-top: 7px;
      }
    }
    .upload {
      display: flex;
      padding-left: 7px;
      align-items: center;
    }
  }
  .title-item {
    align-items: end;
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
